(() => {
  if (window.MHSupportLoaded) return;
  window.MHSupportLoaded = true;
  const contextKeys = ['product', 'variant', 'sku', 'quantity', 'space', 'package', 'source', 'mode', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  const params = new URLSearchParams(location.search);
  const getContext = () => contextKeys.map(key => [key, (params.get(key) || '').replace(/[\u0000-\u001f]/g, '').slice(0, 240)]).filter(([, value]) => value);
  const contextLabels = { product: 'Product', variant: 'Variant', sku: 'SKU', quantity: 'Quantity', space: 'Space', package: 'Package' };
  const showContext = (panel, values, requestLabel) => {
    const lines = values.filter(([key]) => contextLabels[key]).map(([key, value]) => `${contextLabels[key]}: ${value}`);
    if (requestLabel) lines.unshift(requestLabel);
    if (!lines.length) return;
    panel.hidden = false;
    panel.querySelector('[data-mh-request-summary]').textContent = lines.join('\n');
  };
  const init = () => {
    document.querySelectorAll('[data-mh-request-context]').forEach(panel => {
      showContext(panel, getContext());
    });
    document.querySelectorAll('[data-mh-request-link]').forEach(link => {
      const url = new URL(link.getAttribute('href'), location.origin);
      getContext().forEach(([key, value]) => { if (key === 'source' || !url.searchParams.has(key)) url.searchParams.set(key, value); });
      link.href = url.toString();
    });
    const policyRedirect = document.querySelector('[data-mh-policy-redirect]');
    if (policyRedirect) {
      const destination = new URL(policyRedirect.href, location.origin);
      destination.search = location.search;
      if (location.hash) destination.hash = location.hash;
      policyRedirect.href = destination.toString();
      if (!window.Shopify?.designMode) location.replace(destination.toString());
    }
    const legacy = document.querySelector('[data-mh-samples-redirect]');
    if (legacy && !window.Shopify?.designMode) {
      const url = new URL(legacy.href);
      if (!url.searchParams.has('mode')) {
        if (location.hash === '#paid-sample') url.searchParams.set('mode', 'paid_sample');
        if (location.hash === '#material-swatches') url.searchParams.set('mode', 'material_swatch');
      }
      url.hash = url.searchParams.get('mode') === 'paid_sample' ? 'paid-sample' : url.searchParams.get('mode') === 'material_swatch' ? 'material-swatches' : 'materials-samples';
      location.replace(url.toString());
    }
  };
  const closeMenus = except => document.querySelectorAll('[data-mh-support-menu][open]').forEach(menu => { if (menu !== except) menu.open = false; });
  document.addEventListener('toggle', event => {
    const menu = event.target;
    if (menu.matches?.('[data-mh-support-menu]') && menu.open) {
      closeMenus(menu);
      document.querySelectorAll('[data-mh-mega][open]').forEach(item => { item.open = false; });
    } else if (menu.matches?.('[data-mh-mega]') && menu.open) closeMenus();
    if (menu.matches?.('.mh-nav-menu') && !menu.open) closeMenus();
  }, true);
  document.addEventListener('pointerdown', event => {
    document.querySelectorAll('[data-mh-support-menu][open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
  });
  document.addEventListener('focusin', event => {
    document.querySelectorAll('[data-mh-support-menu][open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
  });
  document.addEventListener('keydown', event => {
    const menu = event.target.closest?.('[data-mh-support-menu]');
    if (!menu) return;
    const summary = menu.querySelector('summary');
    const links = Array.from(menu.querySelectorAll('.mh-support-menu__links a'));
    if (event.key === 'Escape' && menu.open) {
      event.preventDefault(); event.stopPropagation(); menu.open = false; summary.focus();
    } else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault(); menu.open = true;
      const index = links.indexOf(event.target);
      const next = index < 0 ? (event.key === 'ArrowDown' ? 0 : links.length - 1) : (index + (event.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length;
      links[next]?.focus();
    }
  }, true);
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-mh-request-copy]');
    if (!button) return;
    const panel = button.closest('[data-mh-request-context]');
    const status = panel.querySelector('[data-mh-request-status]');
    try {
      await navigator.clipboard.writeText(panel.querySelector('pre').textContent);
      status.textContent = status.dataset.copied;
    } catch { status.textContent = status.dataset.copyFailed; }
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-mh-request-link]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!link.hasAttribute('data-mh-willdesk-open') && !link.hasAttribute('data-project-chat')) return;
    const panel = link.closest('[data-project-panel], .mh-samples-section, .mh-resources-directory')?.querySelector('[data-mh-request-context]');
    const samplePanel = panel || link.closest('.mh-resources-directory')?.querySelector('[data-mh-request-context]');
    if (samplePanel) showContext(samplePanel, getContext(), link.textContent.trim());
  }, true);
  matchMedia('(min-width: 990px)').addEventListener('change', () => closeMenus());
  init();
  document.addEventListener('shopify:section:load', init);
})();
